import { render, staticRenderFns } from "./reOrders.vue?vue&type=template&id=003cbb0d&scoped=true&"
import script from "./reOrders.vue?vue&type=script&lang=js&"
export * from "./reOrders.vue?vue&type=script&lang=js&"
import style0 from "./reOrders.vue?vue&type=style&index=0&id=003cbb0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003cbb0d",
  null
  
)

export default component.exports